import React, { useState } from 'react';
import useChat from '../../useChat';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import { Formik } from 'formik';
import { BForm, BSubmit, BTextField } from 'mui-bueno';
import theme from '../../theme';
import { useCardStyles, useOtherStyles } from '../../App';
import { Notification } from '../../@types';
import { getNotifications } from '../../axios/user';
import Typography from '@material-ui/core/Typography';
import ItemList from '../../common/List/ItemList';
import AddIcon from '@material-ui/icons/Add';
import SubmitButton from '../../common/Button/SubmitButton';
import { AppBar, CardHeader, Dialog } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import Card from '@material-ui/core/Card';
import IconButton from '@material-ui/core/IconButton';
import { Cancel, ChatBubble, ChatOutlined } from '@material-ui/icons';
import NotificationsIcon from '@material-ui/icons/Notifications';
import Popover from '@material-ui/core/Popover';
import Badge from '@material-ui/core/Badge';

const useStyles = makeStyles(() => ({
	chatRoomWrapper: {
		position: 'relative',
		height: '70vh',
		maxHeight: '70vh',
		minHeight: '70vh',
		width: '100%',
		overflow: 'scroll'
	},
	messagesContainer: {
		// minHeight: '100px',
		// overflow: 'auto',
		border: '1px solid black',
		borderRadius: '7px 7px 0 0',
		borderColor: '#9a9a9a00',
	},
	sendForm: {
		backgroundColor: theme.palette.primary.light,
		padding: '0px 0px 20px',
	},
	messagesList: {
		listStyleType: 'none',
		padding: 0,
	},
	sendMessageInput: {
		height: '50px',
		fontSize: '20px',
		padding: '15px 15px',
	},
	messageItem: {
		width: '55%',
		maxWidth: '400px',
		margin: '8px',
		padding: '0px 8px',
		wordBreak: 'break-word',
		borderRadius: '20px',
	},
	name: {
		color: 'grey',
		padding: '3px 0px 3px 5px',
	},
	time: {
		color: 'grey',
		padding: '3px 0px 3px 5px',
	},
	message: {
		color: 'white',
		padding: '15px',
		borderRadius: '10px',
	},
	myMessage: {
		marginLeft: 'auto',
		float: 'right',
	},
	myMessageColor: {
		backgroundColor: theme.palette.secondary.main,
	},
	receivedMessage: {
		float: 'left',
	},
	receivedMessageColor: {
		backgroundColor: theme.palette.primary.main
	},
	sendMessageButton: {
		width: '85%',
		margin: 'auto',
		marginTop: '15px',
	},
	gridWrapper: {
		flexGrow: 1,
	},
	noNotifications: {
		textAlign: 'center',
		marginTop: '20px',
	},
	notifications: {
		color: theme.palette.common.white,
	},
	badge: {
		padding: '0 4px',
	},
	popupButton: {
		width: '250px',
		padding: '10px',
		minHeight: '100px',
		backgroundColor: theme.palette.primary.main
	},
	popover: {
	},
	chatTitle: {
		width: '100%',
		height: '50px',
		textAlign: 'center',
		padding: '10px',
		backgroundColor: theme.palette.secondary.dark
	}
}));

const ChatRoom = () => {
	const classes = useStyles();
	const { messages, sendMessage } = useChat();
	const [initialValues, setInitialValues] = useState({
		name: '',
		message: '',
	});

	// const handleNewMessageChange = (event) => {
	// setNewMessage(event.target.value);
	// };

	const handleSubmit = (data: any, actions: any) => {
		sendMessage(data);
		actions.resetForm({
			name: '',
			message: '',
		});
	};


	// const [open, setOpen] = useState(false);
	const cardStyles = useCardStyles();
	const history = useHistory();
	const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
		null
	);
	const open = Boolean(anchorEl);

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const onSelectItem = (id: string | undefined) => {};

	const handleNotifications = () => {
		alert('Implement notifications');
	};

	const [notifications, setNotifications] = React.useState<Notification[]>(
		[]
	);
	React.useEffect(() => {
		getNotifications()
			.then((res: any) => {
				setNotifications(res.data);
			})
			.catch((err: any) => console.log(err));
	}, []);

	return (
		<>
			<IconButton
				onClick={handleClick}
				className={classes.notifications}
				aria-label='cart'
			>
				<Badge
					className={classes.badge}
					badgeContent={0}
					color='secondary'
				>
					<ChatOutlined />
				</Badge>
			</IconButton>
			<Dialog
				open={open}
				// anchorEl={anchorEl}
				onClose={handleClose}
				// anchorOrigin={{
				// 	vertical: 'bottom',
				// 	horizontal: 'center',
				// }}
				// transformOrigin={{
				// 	vertical: 'top',
				// 	horizontal: 'center',
				// }}
				fullWidth
				className={classes.popover}
			>
					<Box className={classes.chatTitle}>
						<Typography>Public Chat Room</Typography>
					</Box>
				<Box className={`${classes.chatRoomWrapper}`}>
				<Box className={`${classes.messagesContainer}`}>
					<ol className={`${classes.messagesList}`}>
						{messages.map((message: any, i: any) => (
							<>
								{message.ownedByCurrentUser ? (
									<li
										key={i}
										className={`${classes.messageItem} ${classes.myMessage}`}
									>
										<Box className={`${classes.name}`}>
											{message.name} at {message.time}
										</Box>
										<Box className={`${classes.message} ${classes.myMessageColor}`}>
											{message.message}
										</Box>
									</li>
								) : (
									<li
										key={i}
										className={`${classes.messageItem} ${classes.receivedMessage}`}
									>
										<Box className={`${classes.name}`}>
											{message.name} at {message.time}
										</Box>
										<Box className={`${classes.message} ${classes.receivedMessageColor}`}>
											{message.message}
										</Box>
									</li>
								)}
							</>
						))}
					</ol>
				</Box>
				</Box>

				<Box className={`${classes.sendForm}`}>
					<Formik
						initialValues={initialValues}
						onSubmit={handleSubmit}
						validateOnChange={false}
						validateOnBlur={false}
					>
						<BForm>
							<BTextField
								name='message'
								full
								required
								// placeholder='Write message...'
								className={`${classes.sendMessageInput}`}
							/>
							<BSubmit
								full
								className={classes.sendMessageButton}
								name='submit'
							>
								Send Message
							</BSubmit>
						</BForm>
					</Formik>
			</Box>
			</Dialog>
		</>
	);
};

export default ChatRoom;
